import {Observable} from 'rxjs';
import {UserOrGroup} from './userOrGroup.model';
import {UserFilterRecipients, UserInUserFilter} from './userInUserfilter.model';
import {SubmitType} from './submit.type';
import {UserFilterDetails} from './userFilterDetails.model';
import {UserFilter} from './user-filter.model';

export class AbstractFacade {
    loadUserAndGroupToAddUserFilter(userFilterId: string): void {};

    getDataSourceId$(): Observable<string> {
       return ;
    }

    getUsersAndGroups$(): Observable<UserOrGroup[]> {
        return ;
    }

    getSelectedColumnValues$(): Observable<string[]> {
        return ;
    }

    loadColumnValues(columnId: string, selectedValues: string[],
                     paginationValues: any, appendValues: boolean = false): void {};

    createUserFilter(columnId: string, name: string, userFilterRecipients:  Partial<UserInUserFilter>[]): void {};

    updateUserFilter(userFilterId: string, name: string, columnId: string,
                     userFilterRecipients: Partial<UserInUserFilter>[]): void {};

    loadUserFilterDetails(userFilter: Partial<UserFilter>): void {};

    loadUserFilterDetailsInViewMode(userFilter: Partial<UserFilter>,
                                    userFilterType: 'Dashboard' | 'Chart' = undefined): void {};

    getUserFilterDetails$(): Observable<UserFilterDetails> {
        return ;
    }

    getSelectedUsersInUserFilter$(): Observable<Partial<UserInUserFilter>[]> {
        return ;
    }

    setSubmitState(submitted: SubmitType): void {};

    getSubmitState$(): Observable<SubmitType> {
        return ;
    }

    addUserToUserFilter(userOrGroup: UserOrGroup): void {};

    removeUserOrGroup(userInUserFilter: Partial<UserInUserFilter>): void {};

    resetUserFilterDetails(): void {};

    resetSelectedColumnValues(): void {};

    resetSelectedUsersOrGroupsInUserFilter(): void {};
}
